module.exports = __webpack_public_path__ + "static/media/app-logo2.1a21201e.svg";